import React, { useState,useEffect } from 'react';
import styles from './UserSelectField.module.css';
import { HiUserCircle, HiEnvelope, HiUserPlus, HiXMark } from 'react-icons/hi2';
import UserSearchGeneric from '../../../utils/UserSearchGeneric/UserSearchGeneric';
import Button from '../../ui/Button';

import avatar from './../../../assets/default-avatar.svg';

export default function UserSelectField({ isCurrentUser, currentUser, cache, setCache, label, selected, onSelect, onPickUser, handleUserSelect, setSearchTarget, isAutoSelect = true }) {
  const [isInviting, setInviting] = useState(false);
  const [isPlayerSelect, setPlayerSelect] = useState(false);
  const [email, setEmail] = useState('');

  const handleInvite = () => {
    if (!email) return;
    onSelect({ email, role: 'invited' });
    setEmail('');
    setInviting(false);
  };
  

	useEffect(() => {
		if(isPlayerSelect == false) {
			if(selected != null)onSelect(selected);
		}
	}, [selected]);

  
  return (
    <div className={styles.container}>
      <label className={styles.label}>{label}</label>

      {selected ? (
        <div className={`${styles.chip} ${isCurrentUser ? styles.you : ''}`}>
		  <img src={selected.profilePicture || avatar} className={styles.icon} alt="" />
          <span>{selected.username || selected.email}</span>
          <Button type="button" className={styles.clearBtn}  onClick={() => onSelect(null)}>
            <HiXMark size={24} />
          </Button>
        </div>
      ) : (
        <>
          <div className={styles.buttons}>
            <Button type="button" className={styles.pickBtn} onClick={() => {onPickUser(); setPlayerSelect(true);}}>
              <HiUserPlus /> Pick User
            </Button>
            <Button
              type="button"
              className={styles.inviteBtn}
              onClick={() => setInviting(true)}>
              <HiEnvelope /> Invite by Email
            </Button>
          </div>

          {isInviting && (
            <div className={styles.inviteForm}>
              <input
                type="email"
                placeholder="email@example.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
              <Button type="button" onClick={handleInvite}>
                <HiEnvelope /> Invite
              </Button>
              <Button
                type="button"
                className={styles.cancel}
                onClick={() => setInviting(false)}>
                Cancel
              </Button>
            </div>
          )}
		  {isPlayerSelect && (
            <div className={styles.inviteForm}>
              <UserSearchGeneric
                cache={cache}
                setCache={setCache}
				        currentUser={currentUser}           // current logged-in user object
                onSelect={user => {	isAutoSelect == true ? handleUserSelect(undefined, user, undefined, undefined, undefined) : onSelect(user); setPlayerSelect(false); }/*handleUserSelect(undefined, user, undefined, undefined)*/}
                onCancel={() => {setPlayerSelect(false); setSearchTarget(null)}}
              />
		  </div>
          )}
        </>
      )}
    </div>
  );
}
